var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"floating-button",attrs:{"color":"primary","fab":"","dark":"","fixed":"","bottom":"","right":"","x-large":""},on:{"click":_vm.openLink}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-whatsapp")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }